<!-- 单元格组件，替换van-cell -->
<template>
  <div :class="cellClass" @click="handleClick">
    <div v-if="$slots.icon || icon" class="mr-3 flex items-center">
      <slot name="icon">
        <!-- Icon组件已移除，现在直接使用插槽 -->
      </slot>
    </div>

    <div class="flex-1 min-w-0 flex-shrink-0">
      <div
        v-if="title || $slots.title"
        class="text-sm text-gray-700 font-medium leading-tight flex-shrink-0"
      >
        <slot name="title">{{ title }}</slot>
      </div>

      <div
        v-if="label || $slots.label"
        class="text-xs text-gray-400 mt-0.5 leading-snug flex-shrink-0"
      >
        <slot name="label">{{ label }}</slot>
      </div>
    </div>

    <div
      v-if="value || $slots.value"
      class="text-gray-500 text-sm ml-3 text-right"
    >
      <slot name="value">{{ value }}</slot>
    </div>

    <div v-if="$slots.rightIcon || isLink" class="ml-2 flex items-center">
      <slot name="rightIcon">
        <ChevronRight v-if="isLink" :size="14" class="text-gray-400" />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ChevronRight } from 'lucide-vue-next'

interface Props {
  title?: string
  value?: string
  label?: string
  icon?: string
  isLink?: boolean
  clickable?: boolean
  disabled?: boolean
  size?: 'large' | 'normal'
}

const props = withDefaults(defineProps<Props>(), {
  isLink: false,
  clickable: false,
  disabled: false,
  size: 'normal'
})

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()

const cellClass = computed(() => {
  const baseClasses = [
    'flex',
    'items-center',
    'px-4',
    'py-3',
    'bg-white',
    'border-b',
    'border-slate-100',
    'transition-all',
    'duration-200',
    'ease-linear',
    'min-h-[44px]',
    'last:border-b-0'
  ]

  const interactiveClasses =
    props.clickable || props.isLink ? ['cursor-pointer'] : []

  const disabledClasses = props.disabled
    ? ['opacity-60', 'cursor-not-allowed']
    : []

  const sizeClasses = props.size === 'large' ? ['p-4', 'min-h-[56px]'] : []

  return [
    ...baseClasses,
    ...interactiveClasses,
    ...disabledClasses,
    ...sizeClasses
  ].join(' ')
})

const handleClick = (event: MouseEvent) => {
  if (!props.disabled) {
    emit('click', event)
  }
}
</script>

<style scoped></style>
